module.exports = __webpack_public_path__ + "img/08.fd74135d.png";